import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import * as React from "react";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import { navSliceActions } from "../../../store/slices/NavSlice";
import { useStoreDispatch, useStoreSelector } from "../../../store/Hooks";
import { interactionTreeSliceActions } from "../../../store/slices/InteractionTreeSlice";
import LanguageSelector from "../../localization/LanguageSelector";
import { useTranslation } from "react-i18next";
import TestToolsButton from "../../test/TestToolsButton";

const testing = process.env.REACT_APP_TEST_MODE === "test";


function ResponsiveAppBar() {
  const currentUser = useStoreSelector((state) => state.auth.userDisplay);
  const navigate = useNavigate();
  const dispatch = useStoreDispatch();

  const goHome = () => {
    dispatch(navSliceActions.clearNavHistory());
    dispatch(interactionTreeSliceActions.replaceState());
    navigate("/");
  };
  
  const { t } = useTranslation();

  return (
    <AppBar position="static">
      <Container maxWidth={false}>
        <Toolbar disableGutters>
          <div style={{ cursor: "pointer" }} onClick={goHome}>
            <img
              style={{ maxHeight: "100px" }}
              src="/caresense_big-removebg-preview.png"
              alt="caresense logo"
            />
          </div>

          <Box sx={{ flexGrow: 0.5 }} />
          <Box sx={{ flexGrow: 1 }} />
          {testing && <span style={{ float: "right" }}>
            <TestToolsButton />
          </span>}
          <Box sx={{ flexGrow: 0 }}>
            <span style={{ float: "left", margin: "15px" }}>
              <Stack direction="row" spacing={2}>
                <Stack direction="column" spacing={0}>
                  <span>{t('login_status')}</span>
                  <span style={{ fontWeight: "bold" }}>{currentUser}</span>
                </Stack>
              </Stack>

            </span>

            <Tooltip title="Open settings">
              <IconButton sx={{ p: 1 }}>
                <Avatar alt="Remy Sharp" sx={{ width: 56, height: 56 }} />
              </IconButton>
            </Tooltip>
            {/* Settings Dropdown */}
            {/* <Menu
              sx={{ mt: "72px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            ></Menu> */}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
